import {
  ENABLE_DISTANCE_READOUT,
  DISABLE_DISTANCE_READOUT
} from '../common/actionTypes';

export const enableDistanceReadout = (distance) => ({
  type: ENABLE_DISTANCE_READOUT,
  distance,
});

export const disableDistanceReadout = () => ({
  type: DISABLE_DISTANCE_READOUT,
});



// WEBPACK FOOTER //
// ./map/actions/distanceReadoutActions.js